import { TransactionType } from './TransactionType';

export const TransactionSource = [
    {
        id: TransactionType.Apvar,
        value: 'APVAR',
    },
    {
        id: TransactionType.Capvar,
        value: 'CAPVAR',
    },
    {
        id: TransactionType.Donation,
        value: 'Donation',
    },
    {
        id: TransactionType.AdminEntry,
        value: 'Admin Entry',
    },
    {
        id: TransactionType.Reward,
        value: 'Reward',
    },
    {
        id: TransactionType.Withdraw,
        value: 'Withdraw',
    },
    {
        id: TransactionType.ApvarGroupOrderRebate,
        value: 'APVAR Group Order Rebate',
    },
    {
        id: TransactionType.CapvarGroupOrderRebate,
        value: 'CAPVAR Group Order Rebate',
    },
    {
        id: TransactionType.ApvarGroupOrderDepositDistribution,
        value: 'APVAR Group Order Deposit Distribution',
    },
    {
        id: TransactionType.CapvarGroupOrderDepositDistribution,
        value: 'CAPVAR Group Order Deposit Distribution',
    },
    {
        id: TransactionType.ApvarGroupOrderDepositReturn,
        value: 'APVAR Group Order Deposit Refund',
    },
    {
        id: TransactionType.CapvarGroupOrderDepositReturn,
        value: 'CAPVAR Group Order Deposit Refund',
    },
    {
        id: TransactionType.ApvarGroupOrderDepositPayment,
        value: 'APVAR Group Order Deposit',
    },
    {
        id: TransactionType.CapvarGroupOrderDepositPayment,
        value: 'CAPVAR Group Order Deposit',
    },
    {
        id: TransactionType.PvcGroupOrderDepositPayment,
        value: 'Practice Valuation Comparison Group Order Deposit',
    },
    {
        id: TransactionType.PvcGroupOrderDepositDistribution,
        value: 'Practice Valuation Comparison Group Order Deposit Distribution',
    },
    {
        id: TransactionType.PvcGroupOrderDepositReturn,
        value: 'Practice Valuation Comparison Group Order Deposit Refund',
    },
    {
        id: TransactionType.PvcGroupOrderRebate,
        value: 'Practice Valuation Comparison Group Order Rebate',
    },
    {
        id: TransactionType.KpiGroupOrderDepositPayment,
        value: 'KPI Benchmarking Group Order Deposit',
    },
    {
        id: TransactionType.KpiGroupOrderDepositDistribution,
        value: 'KPI Benchmarking Group Order Deposit Distribution',
    },
    {
        id: TransactionType.KpiGroupOrderDepositReturn,
        value: 'KPI Benchmarking Group Order Deposit Refund',
    },
    {
        id: TransactionType.KpiGroupOrderRebate,
        value: 'KPI Benchmarking Group Order Rebate',
    },
    {
        id: TransactionType.AccountingStandardizationL12GroupOrderDepositPayment,
        value: 'Accounting Standardization L12M Data Group Order Deposit',
    },
    {
        id: TransactionType.AccountingStandardizationL12GroupOrderDepositDistribution,
        value: 'Accounting Standardization L12M Data Group Order Deposit Distribution',
    },
    {
        id: TransactionType.AccountingStandardizationL12GroupOrderDepositReturn,
        value: 'Accounting Standardization L12M Data Group Order Deposit Refund',
    },
    {
        id: TransactionType.AccountingStandardizationL12GroupOrderRebate,
        value: 'Accounting Standardization L12M Data Group Order Rebate',
    },
    {
        id: TransactionType.VirtualConferenceGroupOrderDepositPayment,
        value: 'Virtual Meeting Group Order Deposit',
    },
    {
        id: TransactionType.VirtualConferenceGroupOrderDepositDistribution,
        value: 'Virtual Meeting Group Order Deposit Distribution',
    },
    {
        id: TransactionType.VirtualConferenceGroupOrderDepositRefund,
        value: 'Virtual Meeting Group Order Deposit Refund',
    },
    {
        id: TransactionType.VirtualConferenceGroupOrderRebate,
        value: 'Virtual Meeting Group Order Rebate',
    },
    {
        id: TransactionType.Kpi,
        value: 'KPI Benchmarking',
    },
    {
        id: TransactionType.Pvc,
        value: 'Practice Valuation Comparison',
    },
    {
        id: TransactionType.PmgPlacementFeeDeposit,
        value: 'PMG Placement Fee Deposit',
    },
    {
        id: TransactionType.PmgPlacementFeeDepositRefund,
        value: 'PMG Placement Fee Deposit Refund',
    },
    {
        id: TransactionType.AccountingStandardizationL24GroupOrderDepositPayment,
        value: 'Accounting Standardization L24M Data Group Order Deposit',
    },
    {
        id: TransactionType.AccountingStandardizationL24GroupOrderDepositDistribution,
        value: 'Accounting Standardization L24M Data Group Order Deposit Distribution',
    },
    {
        id: TransactionType.AccountingStandardizationL24GroupOrderDepositReturn,
        value: 'Accounting Standardization L24M Data Group Order Deposit Refund',
    },
    {
        id: TransactionType.AccountingStandardizationL24GroupOrderRebate,
        value: 'Accounting Standardization L24M Data Group Order Rebate',
    },
    {
        id: TransactionType.AccountingStandardizationL36GroupOrderDepositPayment,
        value: 'Accounting Standardization L36M Data Group Order Deposit',
    },
    {
        id: TransactionType.AccountingStandardizationL36GroupOrderDepositDistribution,
        value: 'Accounting Standardization L36M Data Group Order Deposit Distribution',
    },
    {
        id: TransactionType.AccountingStandardizationL36GroupOrderDepositReturn,
        value: 'Accounting Standardization L36M Data Group Order Deposit Refund',
    },
    {
        id: TransactionType.AccountingStandardizationL36GroupOrderRebate,
        value: 'Accounting Standardization L36M Data Group Order Rebate',
    },
    {
        id: TransactionType.AccountingStandardizationYtdGroupOrderDepositPayment,
        value: 'Accounting Standardization YTD + L3CY Data Group Order Deposit',
    },
    {
        id: TransactionType.AccountingStandardizationYtdGroupOrderDepositDistribution,
        value: 'Accounting Standardization YTD + L3CY Data Group Order Deposit Distribution',
    },
    {
        id: TransactionType.AccountingStandardizationYtdGroupOrderDepositReturn,
        value: 'Accounting Standardization YTD + L3CY Data Group Order Deposit Refund',
    },
    {
        id: TransactionType.AccountingStandardizationYtdGroupOrderRebate,
        value: 'Accounting Standardization YTD + L3CY Data Group Order Rebate',
    },
    {
        id: TransactionType.PmgAnnualSubscription,
        value: 'PMG Annual Subscription',
    },
    {
        id: TransactionType.InitialStandardizationL12MDepositCharge,
        value: 'Accounting Standardization L12M Deposit Charge',
    },
    {
        id: TransactionType.InitialStandardizationL24MDepositCharge,
        value: 'Accounting Standardization L24M Deposit Charge',
    },
    {
        id: TransactionType.InitialStandardizationL36MDepositCharge,
        value: 'Accounting Standardization L36M Deposit Charge',
    },
    {
        id: TransactionType.InitialStandardizationYtdDepositCharge,
        value: 'Accounting Standardization YTD Deposit Charge',
    },
    {
        id: TransactionType.MaintenanceStandardizationMonthlyDepositCharge,
        value: 'Maintenance Standardization Monthly Deposit Charge',
    },
    {
        id: TransactionType.MaintenanceStandardizationQuarterlyDepositCharge,
        value: 'Maintenance Standardization Quarterly Deposit Charge',
    },
    {
        id: TransactionType.MaintenanceStandardizationSemiAnnuallyDepositCharge,
        value: 'Maintenance Standardization Semi-Annually Deposit Charge',
    },
    {
        id: TransactionType.MaintenanceStandardizationAnnuallyDepositCharge,
        value: 'Maintenance Standardization Annually Deposit Charge',
    },
    {
        id: TransactionType.InitialStandardizationL12MFinalPayment,
        value: 'Accounting Standardization L12M Final Payment',
    },
    {
        id: TransactionType.InitialStandardizationL24MFinalPayment,
        value: 'Accounting Standardization L24M Final Payment',
    },
    {
        id: TransactionType.InitialStandardizationL36MFinalPayment,
        value: 'Accounting Standardization L36M Final Payment',
    },
    {
        id: TransactionType.InitialStandardizationYtdFinalPayment,
        value: 'Accounting Standardization YTD Final Payment',
    },
    {
        id: TransactionType.MaintenanceStandardizationMonthlyFinalPayment,
        value: 'Maintenance Standardization Monthly Final Payment',
    },
    {
        id: TransactionType.MaintenanceStandardizationQuarterlyFinalPayment,
        value: 'Maintenance Standardization Quarterly Final Payment',
    },
    {
        id: TransactionType.MaintenanceStandardizationSemiAnnuallyFinalPayment,
        value: 'Maintenance Standardization Semi-Annually Final Payment',
    },
    {
        id: TransactionType.MaintenanceStandardizationAnnuallyFinalPayment,
        value: 'Maintenance Standardization Annually Final Payment',
    },
    {
        id: TransactionType.PmgPlacementFeeRebate,
        value: 'PMG Placement Rebate',
    },
    {
        id: TransactionType.RefundStandardizationDeposit,
        value: 'Standardization Deposit Refund',
    },
    {
        id: TransactionType.VirtualConferenceCharge,
        value: 'Virtual Meeting Charge',
    },
    {
        id: TransactionType.VirtualConferenceRecordingAccess,
        value: 'Virtual Meeting Record Charge',
    },
    { id: TransactionType.VirtualClipVideoAccess, value: 'Video Clip Access' },
    { id: TransactionType.VideoClipCreationPayment, value: 'New Clip' },
    { id: TransactionType.CapvarDeposit, value: 'Capvar Deposit' },
    {
        id: TransactionType.CapvarDepositOverchargeRefund,
        value: 'Capvar Deposit Overcharge Refund',
    },
    { id: TransactionType.SendGiftCard, value: 'Gift Card' },
    { id: TransactionType.ReceiveGiftCard, value: 'Gift Card' },
    { id: TransactionType.IndirectReward, value: 'Indirect Reward' },
    {
        id: TransactionType.ConvertRewardCreditsToFlex,
        value: 'Convert Reward Credits to Flex Credits',
    },
    {
        id: TransactionType.KnowledgeLibraryContent,
        value: 'Knowledge Library Content Access',
    },
    {
        id: TransactionType.UserAnnualSubscriptionPayment,
        value: 'User Annual Subscription Payment',
    },
    {
        id: TransactionType.UserMonthlySubscriptionPayment,
        value: 'User Monthly Subscription Payment',
    },
    {
        id: TransactionType.PayEngagementFinancialModelBuyerSelection,
        value: 'DFM Provision Fee',
    },
    {
        id: TransactionType.PayEngagementIdNdaBuyerSelection,
        value: 'Buyer ID NDA Fee',
    },
    {
        id: TransactionType.PayEngagementDataNdaBuyerSelection,
        value: 'PIP/PIQ Provision Fee',
    },
    {
        id: TransactionType.IdNdaExecutionFee,
        value: 'Seller Identification Fee',
    },
    {
        id: TransactionType.DataNdaExecutionFee,
        value: 'PIP/PIQ Purchase Fee',
    },
    {
        id: TransactionType.FinancialModelDocumentAccessFee,
        value: 'DFM Purchase Fee',
    },
    {
        id: TransactionType.PayEngagementMonthlyRetainerFee,
        value: 'Monthly Engagement Fee',
    },
    {
        id: TransactionType.PayEngagementSuspensionFee,
        value: 'Monthly Suspension Fee',
    },
    {
        id: TransactionType.IdNdaBuyerSelectionRefund,
        value: 'Buyer ID NDA Fee Refund',
    },
    {
        id: TransactionType.DataNdaBuyerSelectionRefund,
        value: 'PIP/PIQ Purchase Fee Refund',
    },
    {
        id: TransactionType.FinancialModelBuyerSelectionRefund,
        value: 'DFM Purchase Fee Refund',
    },
    {
        id: TransactionType.EngagementLateFee,
        value: 'Late Fee',
    },
    {
        id: TransactionType.EngagementDeadlineExtensionFee,
        value: 'Event Deadline Extension Fee',
    },
    {
        id: TransactionType.EngagementTempoChangeFee,
        value: 'Change of Tempo',
    },
    {
        id: TransactionType.BuyerSellerEngagementMeetingFee,
        value: 'Buyer-Seller Meeting Fee',
    },
    {
        id: TransactionType.BuyerSellerEngagementMeetingFeeRefund,
        value: 'Buyer-Seller Meeting Fee Refund',
    },
    {
        id: TransactionType.BuyerSellerEngagementMeetingFeeManualRefund,
        value: 'Manual Buyer-Seller Meeting Fee Refund',
    },
    {
        id: TransactionType.EngagementMonthlyRetainerFeeRefund,
        value: 'Monthly Engagement Fee Refund',
    },
];

export const GiftCardTransactionTypeIds = [
    TransactionType.SendGiftCard,
    TransactionType.ReceiveGiftCard,
];
